import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/login_title.png'
import _imports_2 from '../assets/img/login_text.png'
import _imports_3 from '../assets/img/warning_circle_fill.png'


const _withScopeId = n => (_pushScopeId("data-v-4632cee9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"login-logo\" data-v-4632cee9><img src=\"" + _imports_0 + "\" alt=\"\" data-v-4632cee9></div><div class=\"login-title\" data-v-4632cee9><img src=\"" + _imports_1 + "\" alt=\"\" data-v-4632cee9><img src=\"" + _imports_2 + "\" alt=\"\" data-v-4632cee9></div>", 2)
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "登录/注册")
], -1))
const _hoisted_7 = { class: "login-phone" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手机号注册登录", -1))
const _hoisted_9 = { class: "login-phone" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验证码", -1))
const _hoisted_11 = { class: "login-code" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "login-notice-body" }
const _hoisted_14 = { class: "login-notice" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
            type: "number",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.phone]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
              maxlength: "6",
              type: "text",
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.code]
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCode && _ctx.handleCode(...args))),
              disabled: _ctx.codeTimes > 0,
              style: _normalizeStyle(`opacity:${ _ctx.codeTimes > 0 ? 0.5 : 1 };`)
            }, _toDisplayString(_ctx.codeTimes > 0 ? `已发送(${_ctx.codeTimes})` : '获取验证码'), 13, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.notice), 1)
          ], 512), [
            [_vShow, _ctx.notice]
          ])
        ]),
        _createElementVNode("button", {
          class: "login-btn",
          disabled: !_ctx.phone || !_ctx.code,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)))
        }, "登录", 8, _hoisted_16)
      ])
    ])
  ]))
}